import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import constants from "../../utils/constants";
import _ from "lodash";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function OnTapKegLevelChart() {
  const initialOnTapData = constants.demoOnTapData;
  const labels = _.map(initialOnTapData, (item) => item.name);
  const data = _.map(initialOnTapData, (item) => parseFloat(item.percentFull));

  const backgroundColors = labels.map((_, index) =>
    index % 2 === 0 ? "rgba(218, 119, 68, 0.2)" : "rgba(50, 198, 201, 0.2)"
  );
  const borderColors = labels.map((_, index) =>
    index % 2 === 0 ? "rgba(218, 119, 68, 1)" : "rgba(50, 198, 201, 1)"
  );

  return (
    <Bar
      data={{
        labels: labels,
        datasets: [
          {
            label: "Keg Level (%)",
            data: data,
            backgroundColor: backgroundColors,
            borderColor: borderColors,
            borderWidth: 1,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        plugins: {
          title: {
            display: true,
            text: 'On Tap',
            fullSize: true,
            font: {
              size: 20,
            },
          },
        }
      }}
    />
  );
}
